
export const industryNameList:string[] = [
    '工業',
    '礦業及土石採取業',
    '製造業',
    '電力及燃氣供應業',
    '用水供應及污染整治業',
    '營建工程業',
    '服務業',
    '批發及零售業',
    '運輸及倉儲業',
    '住宿及餐飲業',
    '出版﹑影音製作﹑傳播及資通訊服務業',
    '金融及保險業',
    '不動產業',
    '專業﹑科學及技術服務業',
    '支援服務業',
    '教育業(不含各級公私立學校等)',
    '醫療保健業',
    '藝術﹑娛樂及休閒服務業',
    '其他服務業'
]
export const typeNameList:string[] = [
    '每人每月總薪資(新臺幣元)',
    '每人每月經常性薪資(新臺幣元)',
    '每人每月非經常性薪資(新臺幣元)',
    '每人每月加班費(新臺幣元)',
    '受僱員工人數(人)',
    '進入率(%)',
    '退出率(%)',
    '總工時(小時)',
    '正常工時(小時)',
    '加班工時(小時)'
]
export const yearName:string[] = [
    '102年',
    '103年',
    '104年',
    '105年',
    '106年',
    '107年',
]
export const information = ['薪資', '就業流動', '工時']